"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
var _selectInputs = require("./select-inputs");
// Renders the appropriate UI elements depending on whether or not a typeahead is needed
// and whether or not multiselect is needed. Does not affect the item list, only the
// dropdown button/typeahead input.
const SelectInput = _ref => {
  let {
    useTypeahead,
    multiselect,
    selectedItem,
    selectItem,
    selectedItems = [],
    enableAutoSelect,
    placeholder,
    isOpen,
    inputValue,
    getInputProps,
    getToggleButtonProps,
    getRemoveButtonProps,
    actionIconsPadding,
    safeToggleMenu,
    removeItem,
    itemToString,
    maxLength,
    disabled,
    containsErrors,
    items = [],
    filterItems = () => null,
    onKeyDownProps,
    inputProps
  } = _ref;
  const onKeyDown = event => {
    // If the user hits enter while there is only one option, select it
    if (event.key === 'Enter') {
      const {
        highlightedIndex,
        loading,
        createItemMessage,
        modifyInputValueOnSelectFn
      } = onKeyDownProps;

      // If we are currently loading, we don't allow for selecting a single item.
      // If we are highlighting an item, don't trigger the select here because
      // it will be handled elsewhere.
      if (highlightedIndex || highlightedIndex === 0 || loading) return;

      // Apply the filter to get an accurate count of the items
      const filteredItems = (0, _filter.default)(items).call(items, item => filterItems(itemToString(item), inputValue));

      // If the length of the number of items is 1 with no createItemMessage, or
      // 0 but we have a createItemMessage, we want to select an item. It will
      // be the createItemMessage if present, the first (only) filtered item
      // otherwise.
      const newItem = createItemMessage ? inputValue : filteredItems[0];
      if (filteredItems.length + (createItemMessage ? 1 : 0) === 1) {
        selectItem(newItem, modifyInputValueOnSelectFn({
          oldInputValue: inputValue
        }));
      }
    }
  };
  const sharedProps = {
    placeholder,
    disabled,
    actionIconsPadding,
    containsErrors,
    itemToString,
    inputProps
  };
  if (!multiselect && !useTypeahead) {
    return /*#__PURE__*/_react.default.createElement(_selectInputs.SingleSelectDropdownInput, (0, _extends2.default)({
      selectedItem: selectedItem,
      getToggleButtonProps: getToggleButtonProps
    }, sharedProps));
  }
  if (!multiselect && useTypeahead) {
    return /*#__PURE__*/_react.default.createElement(_selectInputs.SingleSelectTypeaheadInput, (0, _extends2.default)({
      getInputProps: getInputProps,
      safeToggleMenu: safeToggleMenu,
      maxLength: maxLength,
      enableAutoSelect: enableAutoSelect,
      items: items,
      filterItems: filterItems,
      selectItem: selectItem,
      onKeyDown: onKeyDown
    }, sharedProps));
  }
  if (multiselect && !useTypeahead) {
    return /*#__PURE__*/_react.default.createElement(_selectInputs.MultiSelectDropdownInput, (0, _extends2.default)({
      selectedItems: selectedItems,
      getToggleButtonProps: getToggleButtonProps,
      getRemoveButtonProps: getRemoveButtonProps,
      removeItem: removeItem
    }, sharedProps));
  }
  if (multiselect && useTypeahead) {
    return /*#__PURE__*/_react.default.createElement(_selectInputs.MultiSelectTypeaheadInput, (0, _extends2.default)({
      selectedItems: selectedItems,
      isOpen: isOpen,
      inputValue: inputValue,
      getInputProps: getInputProps,
      getRemoveButtonProps: getRemoveButtonProps,
      removeItem: removeItem,
      safeToggleMenu: safeToggleMenu,
      maxLength: maxLength,
      onKeyDown: onKeyDown
    }, sharedProps));
  }
};
var _default = exports.default = SelectInput;
SelectInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectInput",
  "props": {
    "selectedItems": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "filterItems": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "required": false
    }
  }
};